<script>
export default {
  props: {
    campus: null,
  },
  data() {
    return {
      centers: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: "Delivery unit",
          thStyle: { width: "50%" },
          thClass: "align-middle",
        },
        {
          key: "rcCodeGf",
          label: "GF RC Code",
          thClass: "align-middle",
        },
        {
          key: "rcCodeStf",
          label: "STF RC Code",
          thClass: "align-middle",
        },
      ],
      tableBusy: false,
      viewModel: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      if (row.item.showDetails) {
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      } else {
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      }
    },
    selectRow(data) {
      this.$emit("selectRow", data);
    },
    fetchDeliveryUnits() {
      this.$store.commit("deliveryunit/SET_DELIVERY_UNITS_LOADING", true);
      this.$store
        .dispatch("deliveryunit/getDeliveryUnitByCampus", this.campus)
        .then((response) => {
          this.centers = response.data;
          this.$store.commit("deliveryunit/SET_DELIVERY_UNITS_LOADING", false);
        })
        .catch((error) => {
          this.showToast(
            "Cannot fetch available disbursement. Please contact your administrator",
            "error"
          );
        });
    },
  },
  computed: {
    rows() {
      return this.centers.length;
    },
  },
};
</script>

<template>
  <b-modal
    v-model="viewModel"
    id="responsibilityCenterModal"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    title="Select Responsibility Center"
    size="lg"
    @show="fetchDeliveryUnits"
  >
    <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                class="form-select form-select-sm mx-1"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              >
              </b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ms-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>

      <div class="row">
        <div class="col-lg-12 mb-2">
          <small class="text-warning"
            >** Double click row to select responsibility center</small
          >
        </div>
        <!-- table data -->
        <div class="col-lg-12">
          <div class="custom-table-responsive mb-0">
            <b-table
              class="table"
              :items="centers"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :busy="$store.state.deliveryunit.isDeliveryUnitsLoading"
              @filtered="onFiltered"
              show-empty
              bordered
              outlined
              hover
              striped
              select-mode="single"
              selectable
              @row-dblclicked="selectRow"
              selected-variant="info"
            >
              <template #empty="scope">
                <div class="text-center">
                  <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center">
                  <h5 class="text-secondary mb-0">
                    <i class="bx bx-hourglass bx-spin me-2"></i> Fetching data...
                  </h5>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <!-- table data -->
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
